<div class="note-container">
    <p class="note-pii">Entering PII/PHI is prohibited. Click <a href="../../../../dashboardui/pii.html" target="_blank">here</a> for examples of PII/PHI.</p>

    <textarea *ngIf="!editable" readonly rows="16" class="note-text-display" [style.height]="finalHeight + 'vh'">{{readOnlyText}}</textarea>

    <!-- The max length value of 1024 is also set in the back end code -->
    <textarea *ngIf="editable" [(ngModel)]="textAreaText" id="note-text-edit" [style.height]="finalHeight + 'vh'"
        rows="16" maxlength="1024"></textarea>

    <div class="note-footer">
        <button *ngIf="!editable"
                class="btn blue-note-button"
                (click)="addNote()"><em class="material-icons">add</em><span> Add Note</span></button>
        <button *ngIf="editable"
                class="btn blue-note-button"
                (click)="save()"><em class="material-icons">save</em><span> Save</span></button>
        <button *ngIf="editable"
                class="btn gray-note-button"
                (click)="cancel()"><span>Cancel</span></button>
    </div>
</div>
